import React from 'react';
import { CheckCircle } from 'lucide-react';

interface SuccessAlertProps {
  title?: string;
  children: React.ReactNode;
}

export const SuccessAlert: React.FC<SuccessAlertProps> = ({ title, children }) => {
  return (
    <div className='not-prose my-6 bg-green-50 dark:bg-green-950 border-l-4 border-green-500 p-4 rounded-r-lg'>
      <div className='flex gap-3'>
        <CheckCircle className='h-5 w-5 text-green-600 dark:text-green-400 flex-shrink-0 mt-0.5' />
        <div className='flex-1'>
          {title && (
            <h4 className='font-semibold text-green-900 dark:text-green-100 mb-2'>{title}</h4>
          )}
          <div className='text-sm text-green-800 dark:text-green-200 leading-relaxed'>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};
